import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';

import {useMessageOfTheDayQuery} from '../generated/graphql';
import {safeLocalStorage} from '../util/localStorage';
import {Banner, BannerButton} from './Banner';

const MESSAGE_OF_THE_DAY_EVENT_DATA = {location: 'message of the day'};

const MessageOfTheDay: React.FC = () => {
  const {data} = useMessageOfTheDayQuery();

  const lastMessageDismissed = safeLocalStorage.getItem(
    'lastMessageDismissedText'
  );

  const message = data?.serverInfo?.messageOfTheDay;

  if (!message || lastMessageDismissed === message) {
    return null;
  }
  return <MessageOfTheDayLoaded message={message} />;
};

export default MessageOfTheDay;

type MessageOfTheDayLoadedProps = {
  message: string;
};

const MessageOfTheDayLoaded: React.FC<MessageOfTheDayLoadedProps> = ({
  message,
}) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    safeLocalStorage.setItem('lastMessageDismissedText', message);
    setOpen(false);
  };
  if (!open) {
    return null;
  }

  return (
    <Banner eventData={MESSAGE_OF_THE_DAY_EVENT_DATA} variant="announcement">
      <div>{message}</div>
      <BannerButton
        aria-label="Dismiss banner"
        eventData={MESSAGE_OF_THE_DAY_EVENT_DATA}
        onClick={handleClose}
        text={<Icon name="close" />}
        variant="announcement"
      />
    </Banner>
  );
};
